export enum PaymentType {
    PaymentOnTakeOff = 0,
    PixTransfer = 1,
    CreditCard = 2,
    BankTicket = 3
}